"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOption = void 0;
var react_1 = __importDefault(require("react"));
var SelectUtils_1 = require("../SelectUtils");
var SelectOption = function (props) {
    var option = props.option, isSelected = props.isSelected;
    var toRender = SelectUtils_1.formatOption(option);
    if (props.multiple) {
        return (react_1.default.createElement("label", { className: "c-label +check" },
            props.multiple && (react_1.default.createElement("input", { className: "c-input", type: "checkbox", checked: isSelected, readOnly: true })),
            toRender));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null, toRender);
    }
};
exports.SelectOption = SelectOption;
//# sourceMappingURL=SelectOption.js.map